import { DataGridCell } from 'devextreme/common/export/excel';
import { theme } from 'core/Theming/theme';

export const customizeCell = ({
  gridCell,
  excelCell,
}: {
  gridCell?: DataGridCell;
  excelCell?: any;
}) => {
  if (gridCell?.rowType === 'data') {
    let color = theme.palette.background.default;

    const slaBreach = gridCell?.data?.slaBreach;
    if (slaBreach === 1) {
      color = theme.palette.reports.pink;
    }
    if (slaBreach === 0) {
      color = theme.palette.reports.green;
    }

    excelCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {
        argb: color.replace('#', ''),
      },
    };
  }
  if (
    gridCell?.rowType === 'group' &&
    gridCell?.column?.dataField === 'startDTG' &&
    gridCell?.groupSummaryItems
  ) {
    const percentString = String(
      gridCell.groupSummaryItems[0]?.value ?? '0.00%'
    );
    const normalizedPercent = percentString
      .replace('%', '')
      .trim()
      .replace(',', '.');
    const numericSummaryValue = Number(normalizedPercent);

    let color = theme.palette.reports.pink;

    if (numericSummaryValue > 85) {
      color = theme.palette.reports.green;
    }
    if (numericSummaryValue > 75 && numericSummaryValue <= 85) {
      color = theme.palette.reports.orange1;
    }

    excelCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {
        argb: color.replace('#', ''),
      },
    };
  }
};
